module.exports = __webpack_public_path__ + "img/Shopping Cart Check.a97fda09.svg";